import { render, staticRenderFns } from "./valores.vue?vue&type=template&id=84629362"
import script from "./valores.vue?vue&type=script&lang=js"
export * from "./valores.vue?vue&type=script&lang=js"
import style0 from "./valores.vue?vue&type=style&index=0&id=84629362&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports